import { render, staticRenderFns } from "./LmMenuBuilderNewOrEdit.vue?vue&type=template&id=7c265388&"
import script from "./LmMenuBuilderNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmMenuBuilderNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmMenuBuilderNewOrEdit.vue?vue&type=style&index=0&id=7c265388&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports